import { render, staticRenderFns } from "./evolution.vue?vue&type=template&id=8ca08334&scoped=true"
import script from "./evolution.vue?vue&type=script&lang=js"
export * from "./evolution.vue?vue&type=script&lang=js"
import style0 from "./evolution.vue?vue&type=style&index=0&id=8ca08334&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca08334",
  null
  
)

export default component.exports